import { SourceType } from 'types/Source';

const HEADER_NAMES = {
  [SourceType.CSV]: 'Column Header',
  [SourceType.AZURE_AD]: 'Microsoft Graph User Property',
  [SourceType.GOOGLE]: 'Google User Property',
  [SourceType.LDAP]: 'LDAP User Property',
  [SourceType.UKG]: 'UKG User Property',
  [SourceType.OKTA]: 'Okta User Property',
  [SourceType.RHDS]: 'RHDS User Property',
  [SourceType.WORKDAY]: 'Workday Worker Property',
};

export default function getSourceHeaderCopy(sourceType: string) {
  // @ts-ignore
  return HEADER_NAMES[sourceType] || `${sourceType} User Property`;
}
